import { ValidatorFn, FormGroup } from "@angular/forms";
import { _i18n_str } from "../../assets/i18n/non-static-ids";

export function relevantTopicsValidator(): ValidatorFn {
  return (group: FormGroup): { [key: string]: any } | null => {
    let returnValue: {
      valid: boolean;
      error: string;
      errorI18n: string;
    } = null;
    const itemType = group.value.itemType;
    if (itemType !== "DASHBOARD_AREA") {
      const requiredValue = group.value.relevantTopics;
      if (
        requiredValue === null ||
        (Array.isArray(requiredValue) && requiredValue.length === 0)
      ) {
        returnValue = {
          valid: false,
          error:
            "Relevant topics is required if item type is not 'Dashboard area'",
          errorI18n: _i18n_str(
            "RELEVANT_TOPICS.VALIDATION_ERRORS.RELEVANT_TOPICS_REQUIRED"
          )
        };
      }
    }
    return returnValue;
  };
}



// WEBPACK FOOTER //
// ./src/app/validators/relevant-topics-validator.directive.ts